import type { RecurrenceType } from '../components/RecurrencePicker';

const RRULE_MAP: Record<Exclude<RecurrenceType, 'none'>, string> = {
  daily: 'FREQ=DAILY',
  weekdays: 'FREQ=DAILY;BYDAY=MO,TU,WE,TH,FR',
  weekly: 'FREQ=WEEKLY',
  biweekly: 'FREQ=WEEKLY;INTERVAL=2',
  monthly: 'FREQ=MONTHLY',
};

const RECURRENCE_LABELS: Record<string, string> = {
  'FREQ=DAILY': 'Daily',
  'FREQ=DAILY;BYDAY=MO,TU,WE,TH,FR': 'Weekdays',
  'FREQ=WEEKLY': 'Weekly',
  'FREQ=WEEKLY;INTERVAL=2': 'Biweekly',
  'FREQ=MONTHLY': 'Monthly',
};

/** Convert a RecurrenceType preset to an RRULE string. Returns null for 'none'. */
export function recurrenceTypeToRrule(type: RecurrenceType): string | null {
  if (type === 'none') return null;
  return RRULE_MAP[type];
}

/** Convert an RRULE string to a human-readable label. */
export function rruleToLabel(rrule: string): string {
  return RECURRENCE_LABELS[rrule] || 'Custom';
}

/** Convert an RRULE string back to a RecurrenceType. */
export function rruleToRecurrenceType(rrule: string): RecurrenceType {
  for (const [type, rule] of Object.entries(RRULE_MAP)) {
    if (rule === rrule) return type as RecurrenceType;
  }
  return 'none';
}
